import { styled } from '@mui/system';
import { TableCell, TableRow, Typography } from '@mui/material';

// **Logic Functions**

// General row layout for grid alignment
export const StyledTime = styled(Typography)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  justifyContent: 'space-between',
}));

// General row layout for grid alignment
export const StyledTableRow = styled(TableRow)(() => ({
  display: 'grid',
  padding: '11px 8px',
  gap: '4px',
  gridTemplateColumns: `200px repeat(7, minmax(100px, 1fr))`, // First column is wider, all columns have fixed min width to ensure alignement
  alignContent: 'start',
}));

// Layout for shift cells in each column
export const StyledTableCell = styled(TableCell)(() => ({
  display: 'flex',
  gap: '2px',
  flexDirection: 'column',
  padding: '1px 1.5px',
  borderBottom: 'none',
  '& > div': {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
}));

// Styled table cell for the title section
export const StyledTableTitle = styled(TableCell)(({ theme }) => ({
  padding: '0.5rem',
  borderBottom: 'none',
  background: theme.palette.background.secondary,
  borderWidth: '1px 0px',
  borderStyle: 'solid',
  borderColor: '#49454F',
  borderRadius: '24px 4px 4px 24px',
  '& > div': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    height: '100%',
  },
}));

export const EmptyShift = styled('div')(() => ({
  width: '100%',
  padding: '.5rem',
  color: 'rgba(235, 235, 245, 0.6)',
  fontFamily: 'SF Pro Text',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '17px',
  lineHeight: '22px',
  letterSpacing: '-0.4px',
  textAlign: 'center',
}));

// **Shift Cell**
export const StyledShiftBox = styled('div')(({ theme }) => ({
  // Base styles
  width: '100%',
  padding: '.5rem',
  borderStyle: 'solid',
  borderColor: 'transparent',
  borderWidth: '0 1px',
  color: 'rgba(235, 235, 245, 0.6)',
  background: theme.palette.primary.main,
  fontFamily: 'SF Pro Text',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '17px',
  lineHeight: '22px',
  letterSpacing: '-0.4px',
  transition: 'background 0.3s ease, border-color 0.3s ease',
  cursor: 'pointer',

  // Position variations
  '&.single': {
    borderWidth: '1px',
    borderColor: '#49454F',
    borderRadius: '0.5rem',
  },
  '&.first': {
    borderWidth: '1px 1px 0 1px',
    borderColor: '#49454F',
    borderRadius: '0.5rem 0.5rem 0 0',
  },
  '&.last': {
    borderWidth: '0 1px 1px 1px',
    borderColor: '#49454F',
    borderRadius: '0 0 0.5rem 0.5rem',
  },

  // State variations

  '&.current-day': {
    color: theme.palette.text.primary,
    background: theme.palette.background.selected,
    borderColor: '#938F99',
    '&:hover': {
      background: '#3C3C3E',
    },
  },
  '&.selected': {
    color: theme.palette.text.primary,
    background: theme.palette.background.secondarySelected,
    borderColor: '#CEC8D4',
    borderWidth: '2px',
    borderRadius: '0.5rem',
    '&:hover': {
      background: '#2C2C2E',
    },
  },
  '&.unpublished': {
    backgroundColor: theme.palette.success.dark,
    '&:hover': {
      backgroundColor: theme.palette.success.main,
    },
    '&.selected': {
      backgroundColor: theme.palette.success.main,
    },
  },

  // Default hover state
  '&:hover': {
    background: theme.palette.background.secondaryHover,
  },
}));
